var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.stationData),function(item){return _c('el-option',{key:item.id,attrs:{"value":item.id,"label":item.name}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }